export default "__VITE_ASSET__CEIQSD$W__"